import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './Popup.scss';
import { hidePopupContent } from '../../actions/popup';

class Popup extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    hidePopupContent: PropTypes.func.isRequired,
    large: PropTypes.bool,
    open: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    children: false,
    // label: '',
    large: false,
  };

  componentDidUpdate() {
    if (this.props.open) {
      setTimeout(() => {
        this.props.hidePopupContent();
      }, 2000);
    }
  }

  render() {
    const { children, large, open } = this.props;
    const bodyClass = classNames(style.body, { [style.bodyLarge]: large });
    const tipClass = classNames(style.root, { [style.on]: open });

    return (
      <Fragment>
        <button className={style.button} aria-label="Popup"/>
        <div className={tipClass} role="alert">
          <div className={bodyClass}>{children}</div>
        </div>
      </Fragment>
    );
  }
}

const mapState = ({ popup }) => ({ ...popup });
const mapDispatch = { hidePopupContent };

export default injectIntl(connect(mapState, mapDispatch)(withStyles(style)(Popup)));
